export enum TransferenciaActionType {
    TRANSFERENCIA_INDIVIDUAL = "Transferencia Individual",
    NUEVO_CONTACTO = "Nuevo Contacto",
    EDITAR_CONTACTO = "Editar Contacto",
}